import React from "react";
import {NavLink, useNavigate} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import moment from "moment-timezone";
import MemberSidebar from "../../inc/MemberSidebar";
import MD5 from "crypto-js/md5";
import iconTrash from "../../img/icons/icon-trash.svg";
import {confirmAlert} from "react-confirm-alert";
import 'react-quill/dist/quill.snow.css';
import ReactQuill from "react-quill";
import Select from 'react-select'

export default function BusinessInfo(prop) {
    let navigate = useNavigate();

    let member = prop.member;
    let [data, setData] = React.useState(null);

    let [businessType, setBusinessType] = React.useState(null);
    let [businessTypeId, setBusinessTypeId] = React.useState('');
    let [disabledBtn, setDisabledBtn] = React.useState(false);
    let [serviceType, setServiceType] = React.useState(null);
    let [serviceArea, setServiceArea] = React.useState(null);
    let refBusinessNo = React.useRef();
    let refBusinessName = React.useRef();
    let refBusinessAddress = React.useRef();
    let refBusinessEmail = React.useRef();
    let refBusinessPhone = React.useRef();
    let refBusinessWebsite = React.useRef();
    let refBusinessFacebook = React.useRef();
    let refBusinessX = React.useRef();
    let refBusinessArea = React.useRef();
    const [businessInfo, setBusinessInfo] = React.useState('');
    const handleChangeBusinessInfo = (html) => setBusinessInfo(html);

    //Logo
    let [base64LogoImage, setBase64LogoImage] = React.useState(null);
    let [currentLogoImage, setCurrentLogoImage] = React.useState(null);
    let refLogoImageName = React.useRef();
    let refLogoImage = React.useRef();
    const handleClickLogo = React.useCallback(() => refLogoImage.current?.click(), []);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        document.title = 'แก้ไขข้อมูลบริษัท - NCSA';

        (async function() {
            try {
                const resBusinessType = await Utils.getBusinessType();
                setBusinessType(resBusinessType);

                const resServiceType = await Utils.getCyberServiceType();
                const resServiceArea = await Utils.getCyberServiceArea();

                if(member) {
                    const resView = await Utils.getProfile(member);
                    setData(resView);
                    refBusinessNo.current.value = resView.businessNo;
                    refBusinessName.current.value = resView.businessName;
                    refBusinessAddress.current.value = resView.businessAddress;
                    refBusinessEmail.current.value = resView.businessEmail;
                    refBusinessPhone.current.value = resView.businessPhone;
                    refBusinessWebsite.current.value = resView.businessWebsite;
                    refBusinessFacebook.current.value = resView.businessFacebook;
                    refBusinessX.current.value = resView.businessX;
                    refBusinessArea.current.value = resView.businessArea;
                    setBusinessInfo(resView.businessInfo);
                    if(resView.businessTypeId) {
                        setBusinessTypeId(resBusinessType.filter(e => e.id === resView.businessTypeId)[0].id);
                    }

                    //region geo
                    const resProvince = await Utils.getProvince();
                    setProvince(resProvince);
                    refZipcode.current.value = resView.businessZipcode ?? '';
                    if(resView.businessProvinceId) {
                        setProvinceId(resProvince.filter(e => e.id === resView.businessProvinceId)[0]);
                        if(resView.businessAmphurId) {
                            const resAmphur = await Utils.getAmphur(resView.businessProvinceId);
                            setAmphur(resAmphur);
                            setAmphurId(resAmphur.filter(e => e.id === resView.businessAmphurId)[0]);
                            if(resView.businessDistrictId) {
                                const resDistrict = await Utils.getDistrict(resView.businessAmphurId);
                                setDistrict(resDistrict);
                                setDistrictId(resDistrict.filter(e => e.id === resView.businessDistrictId)[0]);
                            }
                        }
                    }
                    //endregion

                    if(resView.businessLogo) {
                        setCurrentLogoImage(Config.fileUpload + 'memberBusinessLogo/' + resView.businessLogo);
                    }

                    if(resServiceType && resView.serviceItem) {
                        for(let rs of resServiceType.rows) {
                            rs.checked = resView.serviceItem.filter(e => e.serviceTypeId === rs.id).length > 0
                        }
                    }
                    if(resServiceArea && resView.areaItem) {
                        for(let rs of resServiceArea.rows) {
                            rs.checked = resView.areaItem.filter(e => e.serviceAreaId === rs.id).length > 0
                        }
                    }
                    setServiceType(resServiceType);
                    setServiceArea(resServiceArea);
                }
            } catch (e) {
                //
            }
        })();

    }, []);

    const onSubmit = async () => {
        let businessNo = refBusinessNo.current.value;
        let businessName = refBusinessName.current.value;
        let businessAddress = refBusinessAddress.current.value;
        let businessEmail = refBusinessEmail.current.value;
        let businessPhone = refBusinessPhone.current.value;
        let businessWebsite = refBusinessWebsite.current.value;
        let businessFacebook = refBusinessFacebook.current.value;
        let businessX = refBusinessX.current.value;
        let businessArea = refBusinessArea.current.value;
        let logoImageName = refLogoImageName.current.value;
        let zipcode = refZipcode.current.value;

        let serviceTypeIds = [];
        let checkboxesType = document.getElementsByName('serviceTypeIds[]');
        for (let i = 0; i < checkboxesType.length; i++) {
            if(checkboxesType[i].checked) {
                serviceTypeIds.push(checkboxesType[i].value);
            }
        }

        let serviceAreaIds = [];
        let checkboxesArea = document.getElementsByName('serviceAreaIds[]');
        for (let i = 0; i < checkboxesArea.length; i++) {
            if(checkboxesArea[i].checked) {
                serviceAreaIds.push(checkboxesArea[i].value);
            }
        }
        if(Utils.MEMBER_TYPE_BUSINESS && !businessTypeId) {
            toast.error('กรุณาระบุ ประเภท');
        }
        else if(!businessNo && (businessTypeId === Utils.BUSINESS_TYPE_LEGAL || businessTypeId === Utils.BUSINESS_TYPE_GROUP)) {
            toast.error(prop.lang === 'en' ? 'Please specify Business No':'กรุณาระบุ หมายเลขนิติบุคคล');
            refBusinessNo.current.focus();
        }
        else if(!businessName) {
            toast.error(prop.lang === 'en' ? 'Please specify Business Name':'กรุณาระบุ ชื่อหน่วยงาน/บริษัท/คณะบุคคล/บุคคล');
            refBusinessName.current.focus();
        }
        else if(!businessAddress) {
            toast.error(prop.lang === 'en' ? 'Please specify Business Address':'กรุณาระบุ ที่อยู่จดทะเบียน');
            refBusinessAddress.current.focus();
        }
        else if(!provinceId) {
            toast.error('กรุณาเลือก จังหวัด');
        }
        else if(!amphurId) {
            toast.error('กรุณาเลือก เขต/อำเภอ');
        }
        else if(!districtId) {
            toast.error('กรุณาเลือก แขวง/ตำบล');
        }
        else if(!zipcode || isNaN(zipcode) || zipcode.length !== 5) {
            toast.error('กรุณาระบุ รหัสไปรษณีย์ ตัวเลข 5 หลัก');
        }
        else if((!businessEmail || !Utils.validateEmail.test(businessEmail))) {
            toast.error(prop.lang === 'en' ? 'Please specify Business Address':'กรุณาระบุ รูปแบบอีเมล หน่วยงาน/บริษัท ให้ถูกต้อง');
            refBusinessEmail.current.focus();
        }
        else if(businessPhone === '') {
            toast.error(prop.lang === 'en' ? 'Please specify Business Address':'กรุณาระบุ เบอร์โทรศัพท์ หน่วยงาน/บริษัท');
            refBusinessPhone.current.focus();
        }
        else if(serviceTypeIds.length <= 0) {
            toast.error(prop.lang === 'en' ? 'Please specify business type':'กรุณาระบุ ประเภทบริการ อย่างน่อย 1 ประเภท');
        }
        else if(serviceAreaIds.length <= 0) {
            toast.error(prop.lang === 'en' ? 'Please specify area type':'กรุณาระบุ พื้นที่บริการ อย่างน่อย 1 อย่าง');
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ยืนยันการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: async () => {
                            setDisabledBtn(true);

                            let logoImage = data.businessLogo;
                            if(logoImageName) {
                                logoImage = MD5(moment().format("YMMDDHHmmss")).toString() + '.' + logoImageName.split('.').pop();
                            }

                            let param = {
                                serviceItems: serviceTypeIds,
                                areaItems: serviceAreaIds,
                                businessTypeId: businessTypeId,
                                businessNo: businessNo,
                                businessName: businessName,
                                businessAddress: businessAddress,
                                provinceId: provinceId.id,
                                amphurId: amphurId.id,
                                districtId: districtId.id,
                                zipcode: zipcode,
                                businessEmail: businessEmail,
                                businessPhone: businessPhone,
                                businessWebsite: businessWebsite,
                                businessInfo: businessInfo,
                                businessFacebook: businessFacebook,
                                businessX: businessX,
                                businessArea: businessArea,

                                businessLogo: logoImage,
                                currentLogoImage: data.businessLogo,
                                base64LogoImage: base64LogoImage,

                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };
                            const result = await updateBusiness(param);
                            if(result) {
                                setDisabledBtn(false);
                                refLogoImageName.current.value = '';
                                if(result.status === 'success') {
                                    toast.success(prop.lang === 'en' ? 'Update business info successfully':'อัพเดตข้อมูลบริษัทเรียบร้อย');
                                }
                                else {
                                    toast.error(prop.lang === 'en' ? 'Sorry, there is a problem. Please contact the administrator':'ขออภัยมีเหตุขัดข้อง กรุณาติดต่อผู้่ดูแลระบบ');
                                }
                            }
                            else {
                                toast.error(prop.lang === 'en' ? 'Sorry, Service is not available at this time. Please contact the administrator.':'ขออภัย ทำรายการได้ในขณะนี้ กรุณาติดต่อผู้่ดูแลระบบ');
                            }
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    async function updateBusiness(param) {
        const response = await fetch(Config.apiUrl +'/member/updateBusiness', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify(param)
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onChangeBusinessType = (x) => {
        if(x) {
            let id = parseInt(x.target.value);
            setBusinessTypeId(id);
            if(id === Utils.BUSINESS_TYPE_PERSON) {
                refBusinessNo.current.value = '';
            }
        }
    };

    //region geo
    let [province, setProvince] = React.useState(null);
    let [provinceId, setProvinceId] = React.useState(null);
    let [amphur, setAmphur] = React.useState(null);
    let [amphurId, setAmphurId] = React.useState(null);
    let [district, setDistrict] = React.useState(null);
    let [districtId, setDistrictId] = React.useState(null);
    let refZipcode = React.useRef();

    const onChangeProvince = async (obj) => {
        setProvinceId(obj);
        setAmphur(null);
        setAmphurId(null);
        setDistrict(null);
        setDistrictId(null);
        refZipcode.current.value = '';
        if(obj) {
            let resAmphur = await Utils.getAmphur(obj.id);
            setAmphur(resAmphur);
        }
    };
    const onChangeAmphur = async (obj) => {
        setAmphurId(obj);
        setDistrict(null);
        setDistrictId(null);
        refZipcode.current.value = '';
        if(obj) {
            let resDistrict = await Utils.getDistrict(obj.id);
            setDistrict(resDistrict);
        }
    };
    const onChangeDistrict = async (obj) => {
        setDistrictId(obj);
        refZipcode.current.value = '';
        if(obj) {
            let resZipcode = await Utils.getZipcode(obj.id);
            refZipcode.current.value = resZipcode.zipcode;
        }
    };
    //endregion

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="businessInfo" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">

                            <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Business Info':'ข้อมูลหน่วยงาน/บริษัท/คณะบุคคล/บุคคล'} <span className={"badge" + (data?.businessStatus == 1 ? ' bg-success':' bg-secondary')}>{data?.businessStatus === 1 ? 'ใช้งาน':'ระงับ'}</span></h3>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Business Type':'ประเภท'} <span className="star">*</span></h6>
                                        <select className="form-select" value={businessTypeId} onChange={onChangeBusinessType}>
                                            <option value="">{prop.lang === 'en' ? 'Select':'กรุณาเลือก'}</option>
                                            {
                                                businessType !== null && businessType.length > 0 ?
                                                    businessType.map((row, index) => {
                                                        return (
                                                            <option key={index} value={row.id}>{prop.lang === 'en' ? row.title_en:row.title}</option>
                                                        )
                                                    }) : ''
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className={"col-sm-6" + (businessTypeId === Utils.BUSINESS_TYPE_LEGAL || businessTypeId === Utils.BUSINESS_TYPE_GROUP ? '':' d-none')}>
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Business Number':'หมายเลขนิติบุคคล'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refBusinessNo} maxLength={100} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Business Name':'หน่วยงาน/บริษัท/คณะบุคคล/บุคคล'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refBusinessName} maxLength={200} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Business Address':'ที่อยู่จดทะเบียน'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refBusinessAddress} maxLength={200} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>จังหวัด <span className="star">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            classNamePrefix="form-select-search"
                                            options={province}
                                            onChange={(event) => onChangeProvince(event)}
                                            value={provinceId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>เขต/อำเภอ <span className="star">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={!amphur}
                                            classNamePrefix="form-select-search"
                                            options={amphur}
                                            onChange={(event) => onChangeAmphur(event)}
                                            value={amphurId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>แขวง/ตำบล <span className="star">*</span></h6>
                                        <Select
                                            isClearable={false}
                                            isDisabled={!district}
                                            classNamePrefix="form-select-search"
                                            options={district}
                                            onChange={(event) => onChangeDistrict(event)}
                                            value={districtId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.title}`}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>รหัสไปรษณีย์ <span className="star">*</span></h6>
                                        <input type="text" className="form-control" id="zipcode" ref={refZipcode} maxLength={5} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Business Email':'อีเมล'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refBusinessEmail} maxLength={200} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Business Phone':'เบอร์โทรศัพท์'} <span className="star">*</span></h6>
                                        <input type="text" className="form-control" ref={refBusinessPhone} maxLength={200} />
                                    </div>
                                </div>
                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Business Website':'เว็บไซต์'}</h6>
                                        <input type="text" className="form-control" ref={refBusinessWebsite} maxLength={200} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>Facebook</h6>
                                        <input type="text" className="form-control" ref={refBusinessFacebook} maxLength={200} />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <h6>X.com</h6>
                                        <input type="text" className="form-control" ref={refBusinessX} maxLength={200} />
                                    </div>
                                </div>

                                <div className="col-sm-12">
                                    <div className="form-group">
                                        <h6>{prop.lang === 'en' ? 'Business Logo':'โลโก้บริษัท'}</h6>
                                        <div className="input-group">
                                            <input type="text" className="form-control" ref={refLogoImageName} readOnly={true} />
                                            <button type="button" className="input-group-text" onClick={handleClickLogo}>เลือกไฟล์ภาพ</button>
                                            <button type="button" className={"input-group-text" + (refLogoImageName?.current?.value ? ' d-block':' d-none')} onClick={e => {
                                                refLogoImageName.current.value = '';
                                                setBase64LogoImage('');
                                            }}><img className="icons svg-js trash" src={iconTrash} alt="" /></button>
                                        </div>
                                        <p className="small text-danger my-1">* ไฟล์ภาพ {Utils.allowImageExtension} ขนาดไม่เกิน {Utils.maxFileImageSizeMb}MB (520x300 pixel)</p>
                                        <input type="file" className="form-control d-none" ref={refLogoImage} onChange={(e) => {
                                            Utils.onSelectImage(e).then(
                                                data => {
                                                    if(data) {
                                                        refLogoImageName.current.value = e.target.files[0].name;
                                                        setBase64LogoImage(data);
                                                    }
                                                }
                                            );
                                        }} accept={Utils.allowImageExtension} />
                                    </div>
                                </div>
                                {
                                    base64LogoImage !== null || currentLogoImage !== null ? <img src={base64LogoImage || currentLogoImage} className="img-fluid" alt="" style={{width:'100%', maxWidth:'260px'}} /> : ''
                                }

                                <div className="col-12">
                                    <label htmlFor="businessInfo" className="form-label">รายละเอียด เกี่ยวกับบริษัท</label>
                                    <ReactQuill theme="snow" modules={Utils.QuillToolbars} value={businessInfo} onChange={handleChangeBusinessInfo} />
                                </div>
                            </div>

                            <h3 className="title-line-left mt-4 mb-4">{prop.lang === 'en' ? 'Service Type':'ประเภทบริการ'}</h3>
                            <div className="row g-3">
                                {
                                    serviceType !== null && serviceType.rows.length > 0 ?
                                        serviceType.rows.map((row, index) => {
                                            return (
                                                <div className="col-12 col-sm-6" key={index}>
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="checkbox" id={"serviceTypeId" + index} name="serviceTypeIds[]" value={row.id} defaultChecked={row.checked} />
                                                        <label className="form-check-label" htmlFor={"serviceTypeId" + index}>
                                                            {prop.lang === 'en' ? row.title_en:row.title}
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        : ''
                                }
                            </div>

                            <h3 className="title-line-left mt-4 mb-4">{prop.lang === 'en' ? 'Service Area':'พื้นที่บริการ'}</h3>
                            <div className="row g-3">
                                {
                                    serviceArea !== null && serviceArea.rows.length > 0 ?
                                        serviceArea.rows.map((row, index) => {
                                            return (
                                                <div className="col-12 col-sm-6" key={index}>
                                                    <div className="form-check lg">
                                                        <input className="form-check-input" type="checkbox" id={"serviceAreaId" + index} name="serviceAreaIds[]" value={row.id} defaultChecked={row.checked} />
                                                        <label className="form-check-label" htmlFor={"serviceAreaId" + index}>
                                                            {prop.lang === 'en' ? row.title_en:row.title}
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        })
                                        : ''
                                }
                                <div className="col-12">
                                    <label htmlFor="businessArea" className="form-label">พื้นที่บริการ อื่นๆ (ถ้ามี)</label>
                                    <input type="text" className="form-control" id="businessArea" ref={refBusinessArea} maxLength={200} placeholder="เอเชียแปซิกฟิก, AEC" />
                                </div>
                            </div>

                            <div className="buttons gap-15 pb-0 my-sm-4">
                                <button className="btn btn-primary w-130" type="button" onClick={onSubmit} disabled={disabledBtn}>
                                    {prop.lang === 'en' ? 'Update':'อัพเดต'}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 